import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import KnowledgeEntriesPaginatedGql from '@/extensions/knowledge-base/store/graphql/queries/KnowledgeEntriesPaginated.gql';
import CreateKnowledgeEntryGql from '@/extensions/knowledge-base/store/graphql/mutations/CreateKnowledgeEntry.gql';
import UpdateKnowledgeEntryGql from '@/extensions/knowledge-base/store/graphql/mutations/UpdateKnowledgeEntry.gql';
import DeleteKnowledgeEntryGql from '@/extensions/knowledge-base/store/graphql/mutations/DeleteKnowledgeEntry.gql';

export default {
    fetchKnowledgeEntriesPaginated: (data, knowledgeSourceId) =>
        new Promise((resolve, reject) => {
            if (!knowledgeSourceId) {
                reject(new Error('knowledge_source_id is required'));
                return;
            }

            const filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: KnowledgeEntriesPaginatedGql,
                    variables: {
                        knowledge_source_id: parseInt(knowledgeSourceId),
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'created_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        filters
                    },
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.EX_AI_KnowledgeEntriesPaginated))
                .catch(err => reject(err));
        }),

    createKnowledgeEntry: ({ knowledgeSourceId, title, body }) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateKnowledgeEntryGql,
                    variables: {
                        knowledge_source_id: parseInt(knowledgeSourceId),
                        title,
                        body
                    }
                })
                .then(({ data }) => resolve(data))
                .catch(err => reject(err));
        }),

    updateKnowledgeEntry: ({ id, title, body }) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateKnowledgeEntryGql,
                    variables: { id: parseInt(id), title, body }
                })
                .then(({ data }) => resolve(data))
                .catch(err => reject(err));
        }),

    deleteKnowledgeEntry: id =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteKnowledgeEntryGql,
                    variables: { id: parseInt(id) }
                })
                .then(({ data }) => resolve(data))
                .catch(err => reject(err));
        })
};
